import invariant from 'invariant';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import querystring from 'query-string';

export default (params) => {
    let { baseUrl, sizeScheme, brandId, country, locale, clientId, uberToken = null, requestOptions = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of getSizeChart()');
    invariant(sizeScheme, 'sizeScheme is a required param of getSizeChart()');
    invariant(brandId, 'brandId is a required param of getSizeChart()');
    invariant(country, 'country is a required param of getSizeChart()');

    const query = querystring.stringify({ locale }); 

    const url = `${baseUrl}search/resources/store/${brandId}_${country.toLowerCase()}/sizechart/scheme/${encodeURIComponent(sizeScheme)}?${query}`;

    return labelRequest(authenticatedRequest(new Request(url, requestOptions), uberToken, clientId), 'getSizeChart');
};
